import React from 'react';
import WeatherWidget from './WeatherWidget';
import PoliceIncidents from './PoliceIncidents';
import AirQualityWidget from './AirQualityWidget';
import ArcGISMap from './ArcGISMap';
import DowntownTrendsChart from './DowntownTrendsChart';
import YearlyTrendsChart from './YearlyTrendsChart';

const OverviewTab = ({ weatherData, downtownData, yearlyData, ArcGISMaps }) => (
  <>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="space-y-6">
        <WeatherWidget data={weatherData} />
        <AirQualityWidget />
      </div>
      <PoliceIncidents />
    </div>
    
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
      <ArcGISMap 
        {...ArcGISMaps.MAIN_MAP}
        title="Crime Patterns and Encampments"
        description="Spatial analysis showing the relationship between reported crime incidents and homeless encampment locations in San Diego"
      />
      <ArcGISMap 
        {...ArcGISMaps.SECONDARY_MAP}
        title="Regional Encampment Distribution"
        description="Geographic distribution of homeless encampments across North City, South Suburban, Central, and East Suburban regions"
      />
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
      <DowntownTrendsChart data={downtownData} />
      <YearlyTrendsChart data={yearlyData} />
    </div>
  </>
);

export default OverviewTab;